<template>
  <div class="container login-page">
    <Menu v-if="!accessToken">
      <template #heading>
        <h1>Account</h1>
      </template>
      <template #content>
        <template v-if="!showForgottenPassword">
          <div class="container">
            <Tabs>
              <Tab name="Login to your account">
                <SingleSignOn />
                <LoginForm @success="handleLoginSuccess" />
                <div class="forgotten-password-button">
                  <Button
                    type="button"
                    full-width
                    theme="outline"
                    @click="showForgottenPassword = true"
                  >
                    Forgotten password?
                  </Button>
                </div>
              </Tab>
              <Tab name="New customer?">
                <RegisterPanel />
              </Tab>
            </Tabs>
          </div>
        </template>

        <AccountRecovery v-if="showForgottenPassword" />
      </template>
    </Menu>

    <Menu v-else>
      <template #heading>
        <h1>Account</h1>
      </template>
      <template #content>
        <div class="container">
          <template v-if="!error">
            <p class="u__text-align--center">Please wait while we log you in</p>
            <Spinner />
          </template>
          <template v-else>
            <p class="error u__text-align--center">{{ error }}</p>
          </template>
        </div>
      </template>
    </Menu>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

import LoginForm from "@/components/account/LoginForm.vue";
import RegisterPanel from "@/components/account/RegisterPanel.vue";
import Button from "@/components/Button.vue";
import Menu from "@/components/Menu";
import SingleSignOn from "@/components/SingleSignOn.vue";
import Spinner from "@/components/Spinner.vue";
import Tab from "@/components/Tab.vue";
import Tabs from "@/components/Tabs.vue";
import AccountRecovery from "@/components/account/AccountRecovery.vue";

export default {
  name: "LoginPage",
  components: {
    LoginForm,
    RegisterPanel,
    AccountRecovery,
    SingleSignOn,
    Tabs,
    Tab,
    Spinner,
    Button,
    Menu,
  },
  data() {
    return {
      showForgottenPassword: false,
      accessToken: null,
      error: false,
    };
  },
  computed: {
    ...mapState("auth", ["multipassAccount"]),
  },
  async created() {
    const params = new Proxy(new URLSearchParams(window.location.search), {
      get: (searchParams, prop) => searchParams.get(prop),
    });

    this.accessToken = params.token;
    const returnUrl = params.return_url;

    if (this.accessToken) {
      try {
        const resp = await this.attemptSSOLogin({
          accessToken: this.accessToken,
          returnUrl,
        });

        if (resp) {
          window.location.href = this.multipassAccount.url;
        } else {
          throw new Error("No customer found");
        }
      } catch (error) {
        console.error(error);
        this.error = "Something went wrong. Please try again.";
      }
    }
  },
  methods: {
    ...mapActions("auth", ["setCustomerAccessToken", "attemptSSOLogin"]),
    handleLoginSuccess() {
      window.location.href = this.multipassAccount.url;
    },
  },
};
</script>

<style lang="scss" scoped>
.error {
  color: $color-red;
}

.login-page {
  width: 100%;
  max-width: 500px;
  margin: 30px auto 0;
}

.forgotten-password-button {
  margin-top: 10px;
}
</style>
